import { createContext, useState, useContext } from 'react'

const PriorityContext = createContext()

export const PriorityProvider = ({ children }) => {
    const [priority, setPriority] = useState(0)

    return (
        <PriorityContext.Provider value={{ priority, setPriority }}>
            {children}
        </PriorityContext.Provider>
    )
}

export const usePriority = () => useContext(PriorityContext)
